/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Nouislider from 'nouislider-react';
import wNumb from 'wnumb';
import { detectTranslateXval, generateRangeFromArray } from '../../Util/data';

const minInvestmentLimit = 1;

const MultiRangeSlider = ({
  onChange,
  locale,
  currencyCode,
  maxInvestmentLimit,
  isDefaultRange,
  investmentRange
}) => {
  const { t } = useTranslation();
  const range = generateRangeFromArray(investmentRange);

  const [values, setValues] = useState([
    minInvestmentLimit,
    maxInvestmentLimit
  ]);

  if (isDefaultRange && values[0] !== minInvestmentLimit) {
    setValues([minInvestmentLimit, maxInvestmentLimit]);
  }

  // eslint-disable-next-line no-shadow
  const updateValues = (values) => {
    setValues(values);
    onChange(values);
  };

  return (
    <div className="relative pt-1 px-3">
      <p className="text-base">
        {t('businessProposal.showProjectsBetween')}&nbsp;
        <span className="text-blue-400">
          {t('currency', {
            val: values[0],
            formatParams: {
              val: {
                currency: currencyCode,
                locale: locale.replace(/_/g, '-'),
                maximumFractionDigits: 0
              }
            }
          })}
        </span>
        &nbsp;{t('businessProposal.and')}&nbsp;
        <span className="text-blue-400">
          {t('currency', {
            val: values[1],
            formatParams: {
              val: {
                currency: currencyCode,
                locale: locale.replace(/_/g, '-'),
                maximumFractionDigits: 0
              }
            }
          })}
        </span>
      </p>
      <div className="my-5" id="multirange-slider">
        <Nouislider
          start={[values[0], values[1]]}
          range={range}
          onUpdate={updateValues}
          snap
          connect
          format={wNumb({
            decimals: 0
          })}
        />
      </div>
    </div>
  );
};

export default MultiRangeSlider;

MultiRangeSlider.propTypes = {
  onChange: PropTypes.func,
  locale: PropTypes.string,
  currencyCode: PropTypes.string,
  maxInvestmentLimit: PropTypes.number,
  isDefaultRange: PropTypes.bool,
  investmentRange: PropTypes.instanceOf(Object)
};

MultiRangeSlider.defaultProps = {
  onChange: () => {},
  locale: '',
  currencyCode: '',
  maxInvestmentLimit: 0,
  isDefaultRange: false,
  investmentRange: null
};
